// extracted by mini-css-extract-plugin
module.exports = {"button":"MintButton_button__2W0uF","container":"MintButton_container__1UHvq","description":"MintButton_description__2pYJo"};